import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { MaterialModal } from 'components/layout'
import AssessorFileUpload from '../../../containers/forms/assessor/AssessorFileUpload/AssessorFileUpload'

export default class AssessorFileUploadModal extends Component {
  static propTypes = {
    colorClass: PropTypes.string,
    modalId: PropTypes.string,
    assessorId: PropTypes.number.isRequired,
    activityId: PropTypes.number.isRequired,
    assessorRegistrationId: PropTypes.number.isRequired,
    activityCategoryId: PropTypes.number.isRequired,
    ajEventId: PropTypes.number.isRequired,
    residentialProjectId: PropTypes.number.isRequired,
    loading: PropTypes.bool,
    authCode: PropTypes.string,
    withoutAssessor: PropTypes.bool

  }

  render() {
    const { colorClass, modalId } = this.props

    return (
      <MaterialModal.Body
        id={modalId}
        colorClass={colorClass}
        title="File upload"
        titleKey="moduleTitle.file_upload"
      >
        <MaterialModal.Content>
          <AssessorFileUpload {...this.props} />
        </MaterialModal.Content>
      </MaterialModal.Body>
    )
  }
}
